import React from 'react';

const Tabs = ({ children, activeTab, onChange }) => {
  return (
    <div className="space-y-4">
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-6" aria-label="Tabs">
          {React.Children.map(children, (child) => {
            // Skip non-Tab components
            if (!child || child.type.displayName !== 'Tab') return null;
            
            const isActive = activeTab === child.props.id;
            
            return (
              <button
                key={child.props.id}
                onClick={() => onChange(child.props.id)}
                className={`
                  whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                  ${isActive 
                    ? 'border-primary-500 text-primary-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
                `}
                aria-current={isActive ? 'page' : undefined}
              >
                {child.props.label}
              </button>
            );
          })}
        </nav>
      </div>
      <div>
        {React.Children.map(children, (child) => {
          // Skip non-Tab components
          if (!child || child.type.displayName !== 'Tab') return null;
          
          // Only render the active tab
          return child.props.id === activeTab ? child : null;
        })}
      </div>
    </div>
  );
};

const Tab = ({ children, id, label }) => {
  return <div>{children}</div>;
};

// Set displayName for proper identification in Tabs component
Tab.displayName = 'Tab';

export { Tabs, Tab };
